import Inherit from '../../core/inherit';
import UsersDelegate from './users.delegate';
import ShelfController from '../../core/shelf.controller';

// Statuses whose server message is written for the person using the panel: no permission (403),
// email unavailable (409, e.g. 'Este correo no está disponible.') and directory down (503).
const SERVER_MESSAGE_STATUSES = [403, 409, 503];

/** The server's message for a failed request with one of those statuses, else null. */
function serverMessage(err) {
    const status = err?.response?.status;
    const message = err?.response?.data?.message;
    return SERVER_MESSAGE_STATUSES.includes(status) && typeof message === 'string' && message ? message : null;
}

/** An error body returned (not thrown) by the API: { success: false, message } or { message, status >= 400 }. */
const isErrorBody = (body) => !body || body.success === false || (typeof body.status === 'number' && body.status >= 400);

class UsersController extends Inherit(ShelfController, UsersDelegate) {
    async initialize() {
        let users = null;
        let clients = [];
        if (this.isAuthenticated) {
            [users, clients] = await Promise.all([
                this.data.fetchUsers(),
                this.data.fetchClients()
            ]);
        } else this.navigateLogin();

        this.setState({ users, rows: users, clients: clients || [], loading: false });
    }

    async createUser(payload) {
        try {
            this.setState({ loading: true });
            const { onMessage } = this.props;

            const user = await this.data.createUser(payload);

            if (!user.name) {
                if (user.message && user.message.includes('duplicate key')) {
                    onMessage('error', 'El correo ya se encuentra registrado');
                } else {
                    onMessage('error', user.message || 'Error al crear el usuario');
                }
                this.setState({ loading: false });
                return false;
            }

            onMessage('success', 'Usuario creado con éxito');
            const users = await this.data.fetchUsers();
            this.setState({ users, rows: users, loading: false });
            this.setIsOpen(false);
            return true;
        } catch (err) {
            console.error('User creation error:', err);
            const { onMessage } = this.props;
            onMessage('error', serverMessage(err) || 'Error inesperado al crear el usuario. Intenta de nuevo.');
            this.setState({ loading: false });
            return false;
        }
    }

    async updateUser(payload) {
        try {
            this.setState({ loading: true });
            const { onMessage } = this.props;
            const { selectedUser } = this.state;

            const response = await this.data.updateUser(selectedUser._id, payload);

            if (!isErrorBody(response)) {
                onMessage('success', 'Usuario actualizado con éxito');
                const users = await this.data.fetchUsers();
                this.setState({ users, rows: users, loading: false, selectedUser: null });
                this.setIsOpen(false);
                return true;
            }
            onMessage('error', response?.message || 'Error al actualizar el usuario');
            this.setState({ loading: false });
            return false;
        } catch (err) {
            console.error('User update error:', err);
            const { onMessage } = this.props;
            onMessage('error', serverMessage(err) || 'Error inesperado al actualizar el usuario. Intenta de nuevo.');
            this.setState({ loading: false });
            return false;
        }
    }

    /** Resolves true when the user was saved; false keeps the drawer open to fix the form. */
    async createOrUpdateUser(payload) {
        const { selectedUser } = this.state;
        if (selectedUser) {
            return this.updateUser(payload);
        }
        return this.createUser(payload);
    }

    fetchStoresByClient = async (clientId) => {
        if (!clientId) return [];
        return (await this.data.fetchStoresByClient(clientId)) || [];
    };

    fetchStoreById = async (storeId) => {
        if (!storeId) return null;
        return (await this.data.fetchStoreById(storeId)) || null;
    };
}

export default UsersController;
